import React, { useEffect } from 'react';

const RightBannerAd: React.FC = () => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // Ignore if AdSense is blocked
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', minWidth: 160, minHeight: 600 }}
      data-ad-client="ca-pub-1984778779085970"
      data-ad-slot="7398606653"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default RightBannerAd; 